import React, { useState } from "react";
import { toast } from "react-toastify";

const shorten = (addr, head = 6, tail = 4) => {
  if (!addr) return "-";
  const s = String(addr);
  if (s.length <= head + tail + 3) return s;
  return `${s.slice(0, head)}...${s.slice(-tail)}`;
};

const AddressCell = ({ address, head = 6, tail = 4 }) => {
  const [copied, setCopied] = useState(false);

  if (!address) return <span>-</span>;

  const handleCopy = async (e) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(address);
      setCopied(true);
      toast.success("Copied to clipboard", { toastId: 'copy-success' });
      setTimeout(() => setCopied(false), 1500);
    } catch (_) {
      toast.error("Copy failed", { toastId: 'copy-error' });
    }
  };

  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
      <span title={address}>{shorten(address, head, tail)}</span>
      <button
        type="button"
        onClick={handleCopy}
        className="btn btn-sm p-0"
        style={{
          border: "none",
          background: "transparent",
          cursor: "pointer",
          color: copied ? "#28a745" : "#6c757d",
          fontSize: 12,
        }}
        aria-label="Copy address"
      >
        {copied ? "✓" : "📋"}
      </button>
    </span>
  );
};

export default AddressCell;
